export enum CorptaxBrandColor {
    Blue = 0,
    White = 1,
}
